import styled from "styled-components";

export const ScreenLayout = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 2fr 7fr;
  grid-template-rows: 10rem 1fr;
  height: 100vh;
  overflow: scroll;
  padding: 3rem 3.2rem;

  & > div:first-of-type {
    grid-column: 1 / 3;
  }

  .menu-mb {
    color: ${(props) => props.theme.colors.gray};
    display: none;
  }

  .clickable-element {
    cursor: pointer;
  }

  @media (max-width: 750px) {
    grid-template-columns: 1fr;
    grid-template-rows: 7rem 12rem 1fr;

    .menu-dt {
      display: none;
    }

    .menu-mb {
      display: block;
    }

    & > div {
      margin-bottom: 1rem;
      margin-top: 1rem;
    }

    & > div:first-of-type {
      grid-column: 1;
      margin-bottom: 0;
      margin-top: 0;
    }
  }
`;
